export default __webpack_public_path__ + "static/media/toy11.343a4897.jfif";